import { FC, useState } from 'react'
import { PhoneInputProps } from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useTheme } from 'styled-components'

import { FormLabelProps } from '../../FormLabel'
import {
  FormFieldOrientation,
  FormFieldOrientationValues,
} from '../../../types/form'

import * as SC from './styled'

export type FormFieldPhoneProps = Omit<PhoneInputProps, 'onChange'> & {
  className?: string
  name: string
  value?: string
  label?: string
  labelProps?: FormLabelProps
  placeholder?: string
  required?: boolean
  disabled?: boolean
  error?: string
  hasError?: boolean
  help?: string
  onChange?: (event: { target: { name: string; value: string } }) => void
  orientation?: FormFieldOrientationValues
}

const FormFieldPhone: FC<FormFieldPhoneProps> = ({
  className,
  name,
  label,
  labelProps,
  error,
  hasError,
  help,
  onChange,
  orientation = FormFieldOrientation.Vertical,
  ...phoneInputProps
}) => {
  const theme = useTheme()
  const [isFocus, setIsFocus] = useState<boolean>(false)
  const isActive = isFocus || !!phoneInputProps.value

  return (
    <SC.Container
      className={className}
      $isDisabled={phoneInputProps.disabled}
      $orientation={orientation}
    >
      {label && (
        <SC.Label
          required={phoneInputProps.required}
          error={!!error || hasError}
          {...labelProps}
        >
          {label}
        </SC.Label>
      )}
      <SC.Input
        preferredCountries={['fr']}
        country={'fr'}
        disableDropdown
        {...phoneInputProps}
        $isDisabled={phoneInputProps.disabled}
        inputStyle={{
          height: 'auto',
          width: '100%',
          minHeight: '4.1rem',
          lineHeight: '1.5',
          fontSize: '1.4rem',
          paddingTop: 0,
          paddingRight: '1.7rem',
          paddingLeft: '1.7rem',
          paddingBottom: 0,
          border: `1px solid ${
            isActive ? theme.colors.bluePrimary : theme.colors.greyContour
          }`,
          backgroundColor: '#FFF',
          borderRadius: '0.6rem',
          color: `${
            error || hasError
              ? theme.colors.error
              : isActive
              ? theme.colors.bluePrimary
              : theme.colors.greyContour
          }`,
        }}
        buttonStyle={{
          borderRadius: '0',
          border: `1px solid ${
            error || hasError ? theme.colors.red : theme.colors.pureBlack
          }`,
          backgroundColor: `${theme.colors.pureWhite}`,
        }}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
        onChange={(value: string) => {
          onChange?.({
            target: {
              name,
              value: `+${value}`,
            },
          })
        }}
      />
      {!error && help && <SC.Help>{help}</SC.Help>}
      {error && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormFieldPhone
